import { useDispatch, useSelector } from "react-redux"
import ButtonComp from "./ButtonComp"
import { GoogleLogin } from "./GoogleLogin"
import useConnectBscWallet from "../../h5/config/useConnectBscWallet"
import { changeBscWalletAddress, changeH5Login } from "../../store/module/h5Login"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { Toast } from "react-vant"
import { useTranslation } from "react-i18next"



const LogoutButton = () => {
  const { t } = useTranslation();
  const { h5LoginType } = useSelector((state: any) => state.h5Login)
  const { disConnectHandle } = useConnectBscWallet()
  const dispatch = useDispatch()
  const logoutCancel = () => {
    localStorage.clear()
    sessionStorage.clear()
    dispatch(changeH5Login({}))
    dispatch(changeBscWalletAddress(""))
    disConnectHandle()
    window.location.href = import.meta.env.VITE_HREF
  }


  return (
    <>
      {h5LoginType?.NT ?
        <GoogleLogin type={0}></GoogleLogin>
        :
        <ButtonComp width={174} title={t("h5.signout")} callBack={() => {
          logoutCancel()
        }}></ButtonComp>
      }
    </>

  )
}
export default LogoutButton